module.exports = __webpack_public_path__ + "static/img/4.e5459c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/15/sp/4.png
// module id = cZys
// module chunks = 0